export default __webpack_public_path__ + "static/media/ic_search.2334f898.svg";